import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { getFormatDate } from "~/libs/getFormatDate";

export type DealerMetricTableRow = {
  dealerId: string;
  dealerName: string;
  category: string;
  posts: string | number;
  plannedSalesNextYear: string | number;
  forecastServiceVisits: string | number;
  actualFrom: string;
  [key: string]: unknown;
};

export const getDealerMetricColumns = (
  t: TFunction
): ColumnsType<DealerMetricTableRow> => [
  {
    title: t("dealerMetrics.dealerId"),
    dataIndex: "dealerId",
    key: "dealerId",
  },
  {
    title: t("dealerMetrics.dealerName"),
    dataIndex: "dealerName",
    key: "dealerName",
  },
  {
    title: t("dealerMetrics.category"),
    dataIndex: "category",
    key: "category",
  },
  {
    title: t("dealerMetrics.posts"),
    dataIndex: "posts",
    key: "posts",
  },
  {
    title: t("dealerMetrics.plannedSalesNextYear"),
    dataIndex: "plannedSalesNextYear",
    key: "plannedSalesNextYear",
  },
  {
    title: t("dealerMetrics.forecastServiceVisits"),
    dataIndex: "forecastServiceVisits",
    key: "forecastServiceVisits",
  },
  {
    title: t("dealerMetrics.actualFrom"),
    dataIndex: "actualFrom",
    key: "actualFrom",
    render: (value: string) => getFormatDate(value),
  },
];
